import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "next-i18next";

const stats = [
    { key: "digital_products", value: 250000 },
    { key: "monthly_active_users", value: 500000 },
    { key: "transactions", value: 86000 },
    { key: "experts", value: 11000 },
];

const SoffStats = () => {
    const { t } = useTranslation("common");

    return (
        <section className={styles.statsWrapper}>
            <img src="/static/img/HomePage/icon.svg" alt="badge" className={styles.icon} />
            <h1 className={styles.title}>{t("stats.title")}</h1>
            <div className={styles.statsGrid}>
                {stats.map((item, idx) => (
                    <div key={idx} className={styles.statCard}>
                        <div className={styles.value}>{item.value.toLocaleString()}+</div>
                        <div className={styles.label}>{t(`stats.items.${item.key}`)}</div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default SoffStats;
